import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { propEq, reject } from 'ramda'
import Classes from './components/classes'
import Cover from './components/cover'
import Info from './components/info'
import Subtitle from './components/subtitle'
import { ArtistEl } from './elements'
import ArtistInfoStore from './stores/artist-info-store'
import loader from '../Loading'
import { withStoreProvider } from '../../Helpers/withStoreProvider'
import { useLocation, withRouter } from 'react-router-dom'

const ArtistInfo = ({ livdemyId }) => {
  let location = useLocation()

  const {
    loading,
    loadFailed,
    updateLivdemyId,
    classes,
  } = ArtistInfoStore.useContainer()

  useEffect(() => {
    updateLivdemyId(livdemyId)
  }, [livdemyId, updateLivdemyId])

  const filteredClasses = useMemo(
    () => reject(propEq('url', location?.pathname))(classes),
    [classes, location],
  )

  return loader(
    loading,
    loadFailed,
    <ArtistEl>
      <div className='row'>
        <Cover />
        <Info />
      </div>
      {Boolean(filteredClasses?.length) && (
        <>
          <Subtitle>Classes by the Artist</Subtitle>
          <Classes />
        </>
      )}
    </ArtistEl>,
  )
}

export default withStoreProvider([ArtistInfoStore])(withRouter(ArtistInfo))

ArtistInfo.propTypes = {
  livdemyId: PropTypes.string.isRequired,
}
